import angular from 'angular';
import './adServices';

const adController = angular.module('applicationModule.adControllers', [
    'applicationModule.adServices',
]);

adController.controller('AdController', ['$scope', '$state', '$rootScope', '$stateParams', 'NgTableParams', 'Ad', 'AppsoupAPI', 'Permissions', 'growl', function ($scope, $state, $rootScope, $stateParams, NgTableParams, Ad, AppsoupAPI, Permissions, growl) {
    'use strict';

    const appId = $stateParams.application_id;
    $scope.writeAccess = Permissions.hasWriteAccess('ads');
    $scope.search = {};

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;

            return Ad.get(appId, params._params).then(function (response) {
                params.total(response.ads.total);
                params.count(response.ads.per_page);
                params.page(response.ads.current_page);
                return response.ads.data;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.newAd = function () {
        $state.go('appsoup.application.adCreate', {'application_id': appId});
    };

    $scope.removeAd = function (id, index) {
        Ad.remove(id).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.AD.DELETE_AD');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.AD.ERROR_DELETE');
            }
        });
    };

    $scope.searchAds = function (search) {
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.contents)) {
            $scope.tableParams._params.contents = undefined;
        }
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

adController.controller('CreateAdController', ['$scope', '$state', '$rootScope', '$stateParams', 'Ad', 'growl', function ($scope, $state, $rootScope, $stateParams, Ad, growl) {
    'use strict';

    const appId = $stateParams.application_id;
    const adId = $stateParams.adId;

    $scope.ad = {};
    $scope.ad.app_id = appId;
    $scope.ad.status = true;

    $scope.isLoading = false;
    $scope.editMode = false;

    if (adId) {
        $scope.editMode = true;
        $scope.isLoading = true;

        Ad.getOne(adId, appId).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.ad = data.ad;
            }
        }).catch(function () {
            $state.go('appsoup.application.ads', {application_id: appId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
            $scope.isLoading = false;
        });
    }

    $scope.saveAd = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.adForm.$valid) {
            $scope.isLoading = true;
            Ad.save($scope.ad, $scope.editMode).then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.AD.' + ($scope.editMode ? 'EDIT' : 'SAVE'));
                    $state.go('appsoup.application.ads', {'application_id': appId});
                } else {
                    growl.error('MODULES.AD.ERROR_SAVE');
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.ads', {'application_id': appId});
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'MODULES.AD.ERROR.TITLE'}],
        'contents': [{type: '$invalid', msg: 'MODULES.AD.ERROR.CONTENTS'}]
    };
}]);

export default adController;
